import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/filter'
import ElementUI from 'element-ui';
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
// 禁止图片右键菜单和拖动保存
document.addEventListener('contextmenu', function(e) {
  // 判断是否点击了图片元素
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
    return false;
  }
});

document.addEventListener('dragstart', function(e) {
  // 阻止图片拖动
  if (e.target.tagName === 'IMG') {
    e.preventDefault();
    return false;
  }
});